<template>
  <div>
    <Title :pages="[{ icon: 'arrow-right', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <v-btn flat class="mb-3 btn-second" @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>
      <v-btn outlined class="ml-3 mb-3 btn-third" @click="updateDialogImportExcel(true)">Importar {{ modal_title }}</v-btn>

      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="mainItem != null && mainItem.id > 0 ? modal_title + ' #' + mainItem.code : modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
        :isClient="isClient()"
      />

      <ModalImportExcel
        v-if="create_access"
        :button_name="'Importar ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        formBtn="Importar"
        :dialog="dialog_import_excel"
        :service="service"
        @updateDialog="updateDialogImportExcel"
        @loadList="loadList(service)"
      />

      <!-- 
        desde
        hasta
        tipo de documento
        estado
        cliente 
        referencia externa 
        -->

      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.date_from" density="comfortable" type="date" name="date_from" label="Desde" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.date_to" density="comfortable" type="date" name="date_to" label="Hasta" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.almacen"
                    density="comfortable"
                    name="almacen"
                    item-title="name"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.code" density="comfortable" label="Numero de envio" :disabled="disabled"></v-text-field>
                </div>
              </div>
              <div class="row pt-2">
                <div class="col">
                  <v-text-field v-model="filters.external_reference" density="comfortable" label="Referencia Externa" :disabled="disabled"></v-text-field>
                </div>
                <div class="col" v-if="!isClient()">
                  <v-combobox
                    v-model="filters.clients"
                    density="comfortable"
                    name="cliente"
                    item-title="name"
                    item-value="id"
                    :items="clients"
                    label="Cliente"
                    autocomplete="off"
                    :disabled="disabled"
                    multiple
                    clearable
                  ></v-combobox>
                </div>
                <div class="col">
                  <v-combobox v-model="filters.product" density="comfortable" item-title="label" item-value="id" :items="products" label="Producto" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col">
                  <v-combobox
                    v-model="filters.canal_venta"
                    density="comfortable"
                    name="canal_venta"
                    item-title="name"
                    item-value="id"
                    :items="canales_venta"
                    label="Canal de Venta"
                    autocomplete="off"
                    :disabled="disabled"
                    multiple
                    clearable
                  ></v-combobox>
                </div>
                <div class="col pt-2" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-3" small dark :loading="dialog_export" @click="exportFile()">
                    Exportar
                    <font-awesome-icon class="ml-2" icon="download" />
                  </v-btn>
                  <v-btn color="info" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-2 pb-2" style="background:rgb(237,237,237); elevation-0">
          <div class="row">
            <div class="col-12">
              <v-btn color="info" variant="text" @click="openFilterModal" small>+ Agregar filtros adicionales</v-btn>

              <v-chip v-for="(filter, index) in selected_filters" :key="index" class="ml-2" closable @click:close="removeFilter(index)"> {{ filter.label }}: {{ filter.value }} </v-chip>
            </div>
          </div>
        </div>
      </v-card>

      <ModalFilterShipment
        v-model="dialog_filters"
        title="Filtros Adicionales"
        :filters="filters"
        :date-types="date_types"
        :document-types="documents_types"
        :status-list="status"
        :sub-clients="sub_clients"
        :loading-sub-clients="loading_sub_clients"
        :is-client="isClient()"
        @update:filters="updateFilters"
        @close="closeFilterModal"
        @apply="applyFilters"
      />

      <v-card>
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col cols="auto">
              <span>{{ page_title }}</span>
            </v-col>
            <v-col>
              <v-btn :color="allExpanded ? 'blue-grey' : 'blue-grey'" variant="outlined" size="small" @click="toggleExpandAll" class="mr-3">
                <v-icon start>{{ allExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                {{ allExpanded ? "Contraer Todo" : "Expandir Todo" }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- v-if="list_access" -->
        <div class="mb-4 mt-2" v-show="update_access">
          <v-menu offset-y v-if="isEmployee()">
            <template v-slot:activator="{ props }">
              <v-icon @click="toggleClass" style="border: 1px solid; border-radius: 100px; padding: 3px" color="blue-grey" :class="isActiveBlinking ? 'ml-4 button_blinking' : 'ml-4'" v-bind="props">
                mdi-dots-vertical
              </v-icon>
            </template>

            <v-list>
              <v-list-item @click="createPickingDetail">
                <v-list-item-title>Reservar stock</v-list-item-title>
              </v-list-item>
              <v-list-item @click="cancelReserve">
                <v-list-item-title>Cancelar reserva</v-list-item-title>
              </v-list-item>
              <v-list-item @click="cancelShipment">
                <v-list-item-title>Cancelar envio</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteShipmentOrders">
                <v-list-item-title>Eliminar órdenes</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openPreparationWave">
                <v-list-item-title>Crear ola de preparación</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openAssignmentModal">
                <v-list-item-title>Asignar a ola de preparación</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openAssignmentModalMuelle">
                <v-list-item-title>Asignar a muelle</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openSyncWms">
                <v-list-item-title>Sincronizar con TMS</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-data-table
          v-if="list_access"
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          v-model="selected"
          :show-select="false"
          loading-text="Cargando..."
          @update:select-all="toggleSelectAll"
        >
          <template v-slot:item="{ item, isSelected, toggleSelect }">
            <tr>
              <td>
                <v-btn variant="text" size="small" @click="toggleExpand(item)" icon>
                  <v-icon>{{ isExpanded(item) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                </v-btn>
              </td>
              <td class="pl-2" v-if="isEmployee()">
                <v-checkbox
                  :disabled="item.status == service.STATUS_EXPEDIDO || item.status == service.STATUS_CANCELADO"
                  style="margin: 0px; padding: 0px"
                  hide-details
                  :model-value="isSelected({ value: item.id })"
                  @update:modelValue="toggleSelect({ value: item.id })"
                />
              </td>
              <td>
                <div class="font-weight-bold" :style="!isClient() && item.wave_id != null ? 'margin-top: 5px; margin-bottom: -5px' : ''">
                  {{ item.code }}
                </div>
                <span class="text-caption text-grey-600" v-if="!isClient()">{{ item.wave != null ? "Ola " + item.wave_id : "" }}</span>
              </td>
              <td v-if="!isClient()">{{ item.client_user_name }}</td>
              <td>
                {{ item.date.split(" ")[0] }}<br />
                <span class="text-caption text-grey-600">{{ item.date.split(" ")[1] || "" }}</span>
              </td>
              <td v-if="isClient()">
                <span class="text-caption text-grey-600">{{ item.almacen_code }}</span>
              </td>
              <td v-if="!isClient()">
                {{ item.dock_name != null ? item.dock_name : "" }}<br />
                <span class="text-caption text-grey-600">{{ item.dock_almacen_code != null ? item.dock_almacen_code : "" }}</span>
              </td>
              <td>{{ item.canal_venta_name != null ? item.canal_venta_name : "-" }}</td>
              <td>
                {{ item.document_type_name }}<br />
                <span v-if="item.external_reference != null" class="table-text-primary-grey"><span class="table-text-secondary">Ref:</span> {{ item.external_reference }}</span>
              </td>
              <td>
                {{ item.address }}
                <p class="text-caption text-grey-600 mb-0">{{ item.location }}</p>
              </td>
              <td>
                <div class="status-badge font-weight-medium" :class="'status-envio-' + (item.status.id || item.status)">
                  {{ item.status_name || (item.status.name ? item.status.name : service.getStatusName(item.status)) }}
                  <p class="text-caption text-grey-600 mb-0">
                    {{ item.sub_status_name || (item.sub_status && item.sub_status.name ? item.sub_status.name : service.getSubStatusName(item.sub_status)) }}
                  </p>
                </div>
              </td>

              <td class="text-center" style="min-width: 120px">
                <!-- Reservar stock -->
                <v-tooltip bottom v-if="!isClient() && item.status == service.STATUS_PENDIENTE_PREPARACION">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue-grey" class="mr-2" v-on:click="createPickingDetail(item)" size="small"> mdi-package </v-icon>
                  </template>
                  <span>Reservar stock</span>
                </v-tooltip>

                <!-- Menú de descargas/impresión -->
                <v-menu v-if="item.status === service.STATUS_EXPEDIDO || item.status === service.STATUS_EMPAQUETADO || item.tms_code" location="bottom" offset-y>
                  <template #activator="{ props }">
                    <v-icon v-bind="props" color="blue-grey" class="mr-2" size="small"> mdi-printer </v-icon>
                  </template>

                  <v-list>
                    <v-list-item v-if="item.status === service.STATUS_EXPEDIDO" @click="printRemito(item)" link>
                      <v-list-item-title>Descargar Remito</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.status === service.STATUS_EXPEDIDO" @click="printRemitoPreimpreso(item)" link>
                      <v-list-item-title>Descargar Remito Preimpreso</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.status === service.STATUS_EXPEDIDO" @click="printRemito(item, true)" link>
                      <v-list-item-title>Ver Remito</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.status === service.STATUS_EXPEDIDO" @click="printRemitoPreimpreso(item, true)" link>
                      <v-list-item-title>Ver Remito Preimpreso</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="item.status === service.STATUS_EXPEDIDO"></v-divider>
                  <v-list-item v-if="item.status === service.STATUS_EMPAQUETADO || item.status === service.STATUS_EXPEDIDO" @click="printPreRemito(item, true)" link>
                    <v-list-item-title>Ver PreRemito</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.status === service.STATUS_EMPAQUETADO || item.status === service.STATUS_EXPEDIDO" @click="printPreRemito(item)" link>
                    <v-list-item-title>Descargar PreRemito</v-list-item-title>
                  </v-list-item>
                  <v-divider v-if="item.status === service.STATUS_EMPAQUETADO || item.status === service.STATUS_EXPEDIDO"></v-divider>
                    <!-- Sin tms_code (canal sin TMS) la etiqueta la genera el WMS -->
                    <v-list-item v-if="item.tms_code || item.status === service.STATUS_EMPAQUETADO || item.status === service.STATUS_EXPEDIDO" @click="openPrintTmsModal(item)" link>
                      <v-list-item-title>Imprimir Etiqueta TMS</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="item.status === service.STATUS_EMPAQUETADO || item.status === service.STATUS_EXPEDIDO" @click="openPrintWitnessModal(item)" link>
                      <v-list-item-title>Imprimir Etiqueta Testigo</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- Ver -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <!-- Menú de más opciones -->
                <v-menu location="bottom" offset-y>
                  <template #activator="{ props }">
                    <v-icon v-bind="props" color="grey-darken-1" size="small"> mdi-dots-vertical </v-icon>
                  </template>

                  <v-list>
                    <!-- Ver LPN -->
                    <v-list-item v-if="!isClient() && (item.status == service.STATUS_EMPAQUETADO || item.status == service.STATUS_PREPARADO)" @click="openViewLpn(item)" link>
                      <template v-slot:prepend>
                        <v-icon color="grey" size="small">mdi-barcode</v-icon>
                      </template>
                      <v-list-item-title>Ver LPN del envío</v-list-item-title>
                    </v-list-item>

                    <!-- Marcar como expedido -->
                    <v-list-item v-if="!isClient() && item.status == service.STATUS_EMPAQUETADO" @click="openShipLpn(item)" link>
                      <template v-slot:prepend>
                        <v-icon color="green" size="small">mdi-truck</v-icon>
                      </template>
                      <v-list-item-title>Marcar como expedido</v-list-item-title>
                    </v-list-item>

                    <!-- Cancelar reserva -->
                    <v-list-item v-if="!isClient() && item.status == service.STATUS_STOCK_RESERVADO && delete_access" @click="cancelReserve(item)" link>
                      <template v-slot:prepend>
                        <v-icon color="black" size="small">mdi-archive-remove</v-icon>
                      </template>
                      <v-list-item-title>Cancelar reserva</v-list-item-title>
                    </v-list-item>

                    <!-- Cierre forzado de preparación -->
                    <v-list-item v-if="!isClient() && update_access && item.status == service.STATUS_EN_PREPARACION" @click="openForceClosePicking(item)" link>
                      <template v-slot:prepend>
                        <v-icon color="orange-darken-2" size="small">mdi-lock-alert</v-icon>
                      </template>
                      <v-list-item-title>Cierre forzado de preparación</v-list-item-title>
                    </v-list-item>

                    <!-- Ver historial -->
                    <v-list-item @click="viewHistorial(item)" link>
                      <template v-slot:prepend>
                        <v-icon color="blue-grey" size="small">mdi-timer</v-icon>
                      </template>
                      <v-list-item-title>Ver historial</v-list-item-title>
                    </v-list-item>

                    <!-- Editar -->
                    <v-list-item v-if="[service.STATUS_PENDIENTE_PREPARACION].includes(item.status) && update_access" @click="editItem(item)" link>
                      <template v-slot:prepend>
                        <v-icon color="blue" size="small">mdi-pencil</v-icon>
                      </template>
                      <v-list-item-title>Editar</v-list-item-title>
                    </v-list-item>

                    <!-- Cancelar envío -->
                    <v-list-item
                      v-if="item.status != service.STATUS_EXPEDIDO && item.status != service.STATUS_CANCELADO && item.status != service.STATUS_PENDIENTE_PREPARACION && delete_access"
                      @click="cancelShipment(item)"
                      link
                    >
                      <template v-slot:prepend>
                        <v-icon color="red" size="small">mdi-close</v-icon>
                      </template>
                      <v-list-item-title>Cancelar envío</v-list-item-title>
                    </v-list-item>

                    <!-- Eliminar -->
                    <v-list-item v-if="item.status == service.STATUS_PENDIENTE_PREPARACION && delete_access" @click="deleteShipmentOrders(item)" link>
                      <template v-slot:prepend>
                        <v-icon color="red" size="small">mdi-delete</v-icon>
                      </template>
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            <tr v-if="isExpanded(item)" :key="`expanded-${item.id}`">
              <td :colspan="headers.length" class="pa-0">
                <div class="pa-4 bg-grey-lighten-5">
                  <h6 class="mb-3 ml-4">Detalles Adicionales</h6>
                  <v-row class="ml-1">
                    <v-col cols="12" md="6">
                      <span class="font-weight-bold pb-1 text-caption">Código TMS</span>
                      <div>{{ item.tms_code != null ? item.tms_code : "-" }}</div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span class="font-weight-bold pb-1 text-caption">Observación</span>
                      <div>{{ item.observation != null ? item.observation : "-" }}</div>
                    </v-col>
                  </v-row>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <ModalSyncWms
        v-if="create_access"
        :button_name="'Sincronizar ' + modal_title"
        :modal_title="'Sincronizar ' + modal_title"
        :page_title="page_title"
        formBtn="Sincronizar"
        :dialog="dialog_sync_wms"
        :service="service"
        :selectedItems="selectedOrdersForSync"
        @update:dialog="updateDialogSyncWms"
        @loadList="loadList(service)"
      />

      <ModalAssignPreparation :dialog="assignment_modal" @updateDialog="updateDialogAssignWave" @assignPreparation="assignToPreparationWave" :loading="loading_assign" />

      <ModalReservarStock
        title="Reservar Stock"
        @updateSelected="selected = $event"
        :dock="selected_dock"
        :dialog_view="dialog_view_reservar"
        :loading="loading_picking_detail"
        :selected="selected_items"
        @closeDialog="closeDialogReservar"
        :headers="headers"
        :confirm="confirmPickDetail"
        @dockMissing="dialog_picking_detail = true"
      />

      <DialogLoading :dialog="loading_create_wave" text="Creando la ola de preparación." />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />

      <ModalAssignMuelle
        title="Asignar muelle"
        button_accept="Asignar"
        :dialog="dialog_assign_muelle"
        @updateDialog="updateDialogMuelle"
        @assignMuelle="assignMuelle"
        :loading="loading_assign_muelle"
        :almacen_selected="almacen_selected"
      />

      <ModalHistorial title="Historial" :dialog_view="dialog_view_historial" :shipment_order_id="shipment_order_id" :code="code_item" @closeDialog="closeDialogHistorial" />

      <ModalViewLpn
        title="LPN del envio "
        :dialog_view="dialog_view_lpn"
        :shipment_order_id="shipment_order_id"
        :almacen="almacen_item"
        :code="code_item"
        @closeDialog="closeDialogViewLpn"
        :getPresentationTypeName="getPresentationTypeName"
        :isEmployee="isEmployee()"
      />

      <ModalAssignMuelle
        :loading="loading_picking_detail"
        :dialog="dialog_picking_detail"
        title="Preparar envío"
        button_accept="Confirmar"
        @updateDialog="updateDialogMuelleReserve"
        @assignMuelle="handleReserve"
        :almacen_selected="almacen_selected"
      />

      <ModalCreatePreparation
        :dialog="dialog_create_wave"
        title="Crear Ola de Preparacion"
        button_accept="Confirmar"
        @updateDialog="
          dialog_create_wave = false;
          selected_shipment_order = null;
        "
        @createPreparationWave="createPreparationWave"
        :shipments="selected"
        :loading="loading_create_wave"
        :toast="toast"
      />

      <DialogYesNo
        :loading="loading_cancel"
        :open="dialog_cancel"
        title="Cancelar Reservas"
        message="¿Estas seguro que desea cancelar las reservas de los envios?"
        @cancel="
          dialog_cancel = false;
          selected_shipment_order = null;
        "
        @accept="cancelReserveConfirm"
      />

      <DialogYesNo
        :loading="loading_cancel_shipment"
        :open="dialog_cencel_shipment"
        title="Cancelar Envios"
        message="¿Estas seguro que desea cancelar los envios?"
        @cancel="
          dialog_cencel_shipment = false;
          selected_shipment_order = null;
        "
        @accept="cancelShipmentConfirm"
      />

      <v-dialog v-model="dialog_force_close_picking" max-width="700" persistent>
        <v-card>
            <v-card-title class="title-modal">
              <span class="headline">Cierre forzado de preparación</span>
            </v-card-title>
            <v-card-text class="pt-0">
            <v-alert type="warning" variant="tonal" class="mb-4">
              Las tareas de picking pendientes serán cerradas de manera forzada, permitiendo que el envío continúe su proceso con los productos ya pickeados.           
            </v-alert>
            <div v-if="force_close_order">
              <p class="font-weight-bold mb-3">Pedido #{{ force_close_order.code }} — Detalle de preparación:</p>
              <v-progress-linear v-if="loading_force_close_details" indeterminate color="orange" class="mb-3" />
              <v-table v-else density="compact">
                <thead>
                  <tr>
                    <th>Producto</th>
                    <th>Cant. esperada</th>
                    <th>Cant. pickeada</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pd in force_close_details" :key="pd.id">
                    <td>{{ pd.product_name }}</td>
                    <td>{{ pd.pd_amount_to_pick }}</td>
                    <td>{{ pd.pt_amount_picked }}</td>
                    <td>
                      <div class="d-flex align-center gap-1">
                        <span class="status-badge" :class="'status-' + pd.pd_status">
                          {{ pickingDetailService.getStatusName(pd.pd_status) }}
                        </span>
                        <v-btn
                          v-if="incidencias_map[pd.pd_id]"
                          variant="text"
                          size="small"
                          icon
                          @click="openIncidencia(incidencias_map[pd.pd_id])"
                          title="Ver incidencia"
                        >
                          <v-icon color="warning">mdi-alert</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="force_close_details.length === 0">
                    <td colspan="4" class="text-center text-grey">Sin detalles</td>
                  </tr>
                </tbody>
              </v-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="red" text @click="closeForceClosePicking" :disabled="loading_force_close">Cancelar</v-btn>
            <v-btn color="green" text :loading="loading_force_close" @click="forceClosePickingConfirm">Confirmar cierre forzado</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <ModalIncidencia
        v-model:dialog="dialog_incidencia"
        :incidencia="selected_incidencia"
      />

      <ModalPrintTms v-model="dialog_print_tms" :shipment_order="shipment_order_for_print" />

      <ModalPrintWitnessShipment
        :show="dialog_print_witness"
        :shipmentOrder="shipment_order_for_witness"
        @close="dialog_print_witness = false; shipment_order_for_witness = null"
      />

      <ModalShipLpn
        :dialog_view="dialog_ship_lpn"
        :shipment_order="shipment_order_selected"
        :almacen="almacen_item"
        :code="code_item"
        @closeDialog="closeDialogShipLpn"
        :getPresentationTypeName="getPresentationTypeName"
        :isEmployee="isEmployee()"
        @reloadList="loadList(service)"
      />
    </v-container>
  </div>
</template>

<script>
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import { subClientService } from "@/libs/ws/subClientService";
import { documentsTypeService } from "@/libs/ws/documentsTypeService";
import { pickingDetailService } from "@/libs/ws/pickingDetailService";
import { generalService } from "@/libs/ws/generalService";
import { canalesVentasService } from "@/libs/ws/canalesVentasService";
import { incidenciaService } from "@/libs/ws/incidenciaService";

import UserTypeConstant from "@/constants/user_type";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Modal from "./Modal.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";
import ModalAssignPreparation from "./ModalAssignPreparation.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import ModalAssignMuelle from "./ModalAssignMuelle.vue";
import ModalImportExcel from "./ModalImportExcel.vue";
import ModalHistorial from "./ModalHistorial.vue";
import ModalCreatePreparation from "./ModalCreatePreparation.vue";
import ModalReservarStock from "./ModalReservarStock.vue";
import ModalSyncWms from "./ModalSyncWms.vue";
import ModalViewLpn from "./ModalViewLpn.vue";
import ModalShipLpn from "./ModalShipLpn.vue";
import ModalPrintTms from "./ModalPrintTms.vue";
import ModalPrintWitnessShipment from "./ModalPrintWitnessShipment.vue";
import { productoService } from "@/libs/ws/productoService";
import ModalFilterShipment from "./ModalFilterShipment.vue";
import ModalIncidencia from "../PickingDetail/ModalIncidencia.vue";

export default {
  components: {
    Modal,
    DialogDelete,
    DialogYesNo,
    DialogLoading,
    ModalAssignPreparation,
    ModalAssignMuelle,
    ModalImportExcel,
    ModalHistorial,
    ModalCreatePreparation,
    ModalReservarStock,
    ModalSyncWms,
    ModalViewLpn,
    ModalPrintTms,
    ModalPrintWitnessShipment,
    ModalShipLpn,
    ModalFilterShipment,
    ModalIncidencia,
  },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      service: shipmentOrderService,
      pickingDetailService: pickingDetailService,
      page_title: "Ordenes de envio",
      modal_title: "Orden de envio",
      documents_types: [],
      clients: [],
      sub_clients: [],
      loading_sub_clients: false,
      almacenes: [],
      status: [],
      date_types: [
        { id: "date", name: "Fecha de envío" },
        { id: "departure_date", name: "Fecha de expedición" },
      ],
      userTypeConstant: UserTypeConstant,
      user_type: null,
      headers: [
        { text: "", value: "expand", sortable: false, width: "30px" },
        { text: "", value: "data-table-select", sortable: false, width: "40px", visible_for_client: false },
        {
          title: "Numero",
          align: "left",
          sortable: true,
          key: "code",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client_user_name",
          visible_for_client: false,
        },

        {
          title: "Fecha",
          align: "left",
          sortable: true,
          key: "date",
        },
        {
          title: "Almacen",
          align: "left",
          sortable: true,
          key: "almacen_code",
          only_for_client: true,
        },
        {
          title: "Muelle",
          align: "left",
          sortable: true,
          key: "dock.id",
          visible_for_client: false,
        },
        {
          title: "Canal de Venta",
          align: "left",
          sortable: true,
          key: "canal_venta_name",
        },
        {
          title: "Documento",
          align: "left",
          sortable: true,
          key: "external_reference",
        },
        {
          title: "Destino",
          align: "left",
          sortable: true,
          key: "address",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "status_name",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
      filters: {
        date_type: { id: "date", name: "Fecha de envío" },
        date_from: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        estimated_arrival_date: "",
        document_type: null,
        status: [],
        clients: [],
        sub_clients: [],
        almacen: null,
        canal_venta: [],
        product: null,
        code: "",
        external_reference: "",
        tms_code: "",
        not_synced_tms: false,
      },
      dialog_picking_detail: false,
      loading_picking_detail: false,
      selected_shipment_order: null,
      selected: [],
      dialog_create_wave: false,
      assignment_modal: false,
      selectedPreparation: null,
      loading_create_wave: false,
      dialog_cancel: false,
      loading_cancel: false,
      dialog_assign_muelle: false,
      loading_assign_muelle: false,
      dialog_import_excel: false,
      dialog_view_historial: false,
      shipment_order_id: null,
      shipment_order_selected: null,
      isActiveBlinking: false,
      dialog_cencel_shipment: false,
      loading_cancel_shipment: false,
      dialog_force_close_picking: false,
      loading_force_close: false,
      loading_force_close_details: false,
      force_close_order: null,
      force_close_details: [],
      incidencias_map: {},
      dialog_incidencia: false,
      selected_incidencia: null,
      loading_canales_venta: false,
      canales_venta: [],
      selected_dock: null,
      selected_items: [],
      is_single_reserve: false,
      search: "",
      shipment_a_expedir_selected: null,
      dialog_expedir: false,
      loading_expedir: false,
      loading_sync_tms: false,
      dialog_sync_wms: false,
      selectedOrdersForSync: [],
      expandedItems: [],
      allExpanded: false,
      dialog_view_lpn: false,
      dialog_ship_lpn: false,
      almacen_item: null,
      code_item: null,
      products: [],
      dialog_print_tms: false,
      shipment_order_for_print: null,
      dialog_print_witness: false,
      shipment_order_for_witness: null,
      almacen_selected: null,
      selected_filters: [],
      dialog_filters: false,
    };
  },
  mounted() {
    this.user_type = localStorage.getItem("user_type");
    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    //recorro los headers y saco el cliente si el usuario es el cliente
    this.headers = this.headers.filter((header) => {
      // Si tiene only_for_client: true, solo mostrar para clientes
      if (header.only_for_client) {
        return this.isClient();
      }
      // Si tiene visible_for_client: false, solo mostrar para no-clientes (admins)
      if (header.visible_for_client === false) {
        return !this.isClient();
      }
      // Si no tiene ninguna restricción o visible_for_client es undefined/true, mostrar a todos
      return true;
    });

    this.loadList(this.service);
    this.loadAlmacenes();
    this.loadClientes();
    this.loadSubClients();
    this.loadDocumentTypes();
    this.loadStatus();
    this.loadCanalesVentas();
    this.loadProducts();
  },
  watch: {
    selected: function () {
      if (this.selected.length > 0) {
        this.isActiveBlinking = true;
      } else {
        this.isActiveBlinking = false;
      }
    },
    list: function () {
      // Reset accordion state when list changes
      this.expandedItems = [];
      this.allExpanded = false;
    },
  },
  methods: {
    isAnyDialogOpen() {
      return this.dialog || 
             this.dialog_delete ||
             this.dialog_import_excel || 
             this.dialog_picking_detail || 
             this.dialog_create_wave || 
             this.assignment_modal || 
             this.dialog_cancel || 
             this.dialog_assign_muelle || 
             this.dialog_view_historial || 
             this.dialog_cencel_shipment || 
             this.dialog_force_close_picking ||
             this.dialog_sync_wms || 
             this.dialog_view_lpn || 
             this.dialog_ship_lpn || 
             this.dialog_print_tms || 
             this.dialog_expedir || 
             this.dialog_view_reservar;
    },
    viewItem(item) {
      this.viewdIndex = this.list.indexOf(item);

      shipmentOrderService
        .get({ id: item.id })
        .then((response) => {
          this.mainItem = response.result;
          this.dialog = true;
        })
        .catch((e) => {
          console.log("service.get error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      shipmentOrderService
        .get({ id: item.id })
        .then((response) => {
          this.mainItem = response.result;
          this.dialog = true;
        })
        .catch((e) => {
          console.log("service.get error");
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getFilterParams() {
      let params = { ...this.filters };

      if (Array.isArray(params.clients) && params.clients.length > 0) {
        params.client_ids = params.clients
          .map((client) => parseInt(client.id))
          .filter((id) => !Number.isNaN(id) && id > 0);
      } else if (params.client && params.client.id) {
        const singleClientId = parseInt(params.client.id);
        if (!Number.isNaN(singleClientId) && singleClientId > 0) {
          params.client_ids = [singleClientId];
        }
      }

      delete params.clients;
      delete params.client;

      // Canal de venta múltiple -> canal_venta_ids
      if (Array.isArray(params.canal_venta) && params.canal_venta.length > 0) {
        params.canal_venta_ids = params.canal_venta
          .map((cv) => parseInt(cv.id))
          .filter((id) => !Number.isNaN(id) && id > 0);
      }
      delete params.canal_venta;

      // Punto de entrega múltiple -> sub_client_ids
      if (Array.isArray(params.sub_clients) && params.sub_clients.length > 0) {
        params.sub_client_ids = params.sub_clients
          .map((sc) => parseInt(sc.id))
          .filter((id) => !Number.isNaN(id) && id > 0);
      }
      delete params.sub_clients;

      // Transformar los parámetros según el tipo de fecha seleccionado
      if (params.date_type && params.date_type.id === "departure_date") {
        // Si está seleccionado fecha de expedición, usar departure_date_from/to
        params.departure_date_from = params.date_from;
        params.departure_date_to = params.date_to;
        // Limpiar date_from/to para que no se filtren por fecha de creación
        delete params.date_from;
        delete params.date_to;
      }
      // Si es 'date' (por defecto), los parámetros date_from/date_to ya están correctos

      // Remover date_type ya que no se usa en el backend
      delete params.date_type;

      // Si status es un array con múltiples estados, usar status_arr
      if (Array.isArray(params.status) && params.status.length > 0) {
        params.status_arr = params.status;
        delete params.status;
      } else if (Array.isArray(params.status) && params.status.length === 0) {
        // Si es un array vacío, eliminar el parámetro
        delete params.status;
      }

      // Actualizar selected_filters para mostrar los chips
      const statusValue = Array.isArray(this.filters.status) && this.filters.status.length > 0
        ? this.filters.status.map(s => s.name).join(", ")
        : "";

      this.selected_filters = [
        { key: "date_type", label: "Fecha de búsqueda", value: this.filters.date_type?.name || "" },
        { key: "clients", label: "Clientes", value: Array.isArray(this.filters.clients) && this.filters.clients.length > 0 ? this.filters.clients.map((c) => c.name).join(", ") : "" },
        { key: "wave_id", label: "Ola", value: this.filters.wave_id || "" },
        { key: "tms_code", label: "Código TMS", value: this.filters.tms_code || "" },
        { key: "document_type", label: "Tipo de documento", value: this.filters.document_type?.name || "" },
        { key: "status", label: "Estado", value: statusValue },
        { key: "canal_venta", label: "Canal de Venta", value: Array.isArray(this.filters.canal_venta) && this.filters.canal_venta.length > 0 ? this.filters.canal_venta.map((cv) => cv.name).join(", ") : "" },
        { key: "sub_clients", label: "Punto de entrega", value: Array.isArray(this.filters.sub_clients) && this.filters.sub_clients.length > 0 ? this.filters.sub_clients.map((sc) => sc.label || sc.name).join(", ") : "" },
        { key: "not_synced_tms", label: "No sincronizado con TMS", value: this.filters.not_synced_tms ? "Sí" : "" },
      ].filter((f) => f.value);

      params.limit = 0;
      return params;
    },
    loadProducts() {
      productoService.list_minify().then((response) => {
        this.products = response.result.list;
      });
    },
    updateDialogMuelleReserve() {
      this.dialog_picking_detail = false;
      this.is_single_reserve = false;
      this.selected_shipment_order = null;
      this.selected = [];
      this.filter();
    },
    async handleReserve(dock) {
      if (this.is_single_reserve) {
        const shipment_order_id = this.selected[0];
        await this.confirmPickDetail(shipment_order_id, dock);
        this.updateDialogMuelleReserve();
        return;
      }

      // Flujo masivo
      if (this.selected.length === 0) {
        this.toast.error("No se ha seleccionado ninguna orden de envío");
        return;
      }

      this.selected_dock = dock;
      this.dialog_picking_detail = false;
    },

    closeDialogReservar() {
      this.dialog_view_reservar = false;
      this.selected_dock = null;
      this.selected_shipment_order = null;
      this.selected = [];
      this.filter();
    },
    loadCanalesVentas() {
      this.loading_canales_venta = true;
      canalesVentasService
        .filter({})
        .then((response) => {
          this.canales_venta = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_canales_venta = false;
        });
    },
    printRemito(item, open = false) {
      this.loading = true;
      shipmentOrderService
        .print_remito(item.id)
        .then((response) => {
          let nombre = item.code;
          if (!generalService.downloadPdf(response, "Orden de Envio-" + nombre + ".pdf", open)) {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    printRemitoPreimpreso(item, open = false) {
      this.loading = true;
      shipmentOrderService
        .print_remito_preimpreso(item.id)
        .then((response) => {
          let nombre = item.code;
          if (!generalService.downloadPdf(response, "Orden de Envio Preimpreso-" + nombre + ".pdf", open)) {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    printPreRemito(item, open = false) {
      this.loading = true;
      shipmentOrderService
        .print_pre_remito(item.id)
        .then((response) => {
          if (!generalService.downloadPdf(response, "PreRemito-" + item.code + ".pdf", open)) {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleClass() {
      this.isActiveBlinking = false;
    },
    viewHistorial(item) {
      this.shipment_order_id = item.id;
      this.code_item = item.code;
      this.dialog_view_historial = true;
    },
    closeDialogHistorial() {
      this.shipment_order_id = null;
      this.code_item = null;
      this.dialog_view_historial = false;
    },
    updateDialogImportExcel(value) {
      if (!value) {
        this.close();
      }
      this.dialog_import_excel = value;
    },
    updateDialogSyncWms(value) {
      if (!value) {
        // Reset selections when dialog closes
        this.selectedOrdersForSync = [];
      }
      this.dialog_sync_wms = value;
    },
    updateDialogAssignWave() {
      this.assignment_modal = false;
    },
    updateDialogMuelle() {
      this.dialog_assign_muelle = false;
    },
    toggleSelectAll(isSelected) {
      console.log("toggleSelectAll 1", isSelected);
      if (isSelected) {
        const selectableItems = this.list.filter((item) => item.wave === null);
        this.selected = selectableItems.map((item) => item.id);
      } else {
        // Desmarcar todo
        this.selected = [];
      }
    },
    assignMuelle(item) {
      this.loading_assign_muelle = true;
      const param = {
        shipment_orders_ids: this.selected,
        dock: { id: item.id },
      };

      this.service
        .assign_dock(param)
        .then((response) => {
          if (response.status) {
            this.toast.success("El muelle se asigno correctamente.");
            this.loadList(this.service);
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.toast.error(response.message);
            } else {
              this.toast.error(response.msg);
            }
          }
        })
        .catch((e) => {
          this.toast.error(e);
        })
        .finally(() => {
          this.loading_assign_muelle = false;
          this.dialog_assign_muelle = false; // Cierra el modal
        });
    },
    openSyncWms() {
      if (this.selected.length === 0) {
        this.toast.error("No se ha seleccionado ninguna orden de envío");
        return;
      }

      this.selectedOrdersForSync = this.list.filter((item) => this.selected.includes(item.id));

      this.dialog_sync_wms = true;
    },
    openAssignmentModalMuelle(item = null) {
      if (item && item.id) {
        console.log("openAssignmentModalMuelle", item);
      } else {
        if (this.selected.length === 0) {
          this.toast.error("No se ha seleccionado ninguna orden de envío");
          return;
        }
        this.selected_items = this.list.filter((item) => this.selected.includes(item.id));
        //Validar que todos los selected_items sean del mismo almacen
        const almacen_id = this.selected_items[0].almacen_id;
        const all_same_almacen = this.selected_items.every((item) => item.almacen_id === almacen_id);
        if (!all_same_almacen) {
          this.selected_items = [];
          this.toast.error("Los items seleccionados deben pertenecer al mismo almacen");
          return;
        }

        this.almacen_selected = { id: this.selected_items[0].almacen_id, name: this.selected_items[0].almacen_name, code: this.selected_items[0].almacen_code };
        console.log("openAssignmentModalMuelle", this.almacen_selected);
      }

      this.dialog_assign_muelle = true;
    },
    openPreparationWave() {
      this.dialog_create_wave = true;
      console.log(this.selected);
    },
    createPreparationWave(item) {
      this.loading_create_wave = true;
      const params = {
        almacen: { id: item.almacen_id, name: item.almacen_name, code: item.almacen_code },
        dock: item.dock,
        description: item.description,
        shipment_orders: this.selected,
      };

      shipmentOrderService
        .create_wave(params)
        .then((response) => {
          if (response.status) {
            console.log(response);
            this.toast.success("La ola de preparacion se creo correctamente.");
            this.dialog_create_wave = false;
            this.loadList(this.service);
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.toast.error(response.message);
            } else {
              this.toast.error(response.msg);
            }
          }
        })
        .catch((e) => {
          this.toast.error(e);
        })
        .finally(() => {
          this.loading_create_wave = false;
        });
    },
    openAssignmentModal() {
      this.assignment_modal = true;
    },
    assignToPreparationWave(item) {
      this.loading_assign = true;
      const param = {
        shipment_orders: this.selected,
        wave: item.id,
      };

      this.service
        .assign_wave(param)
        .then((response) => {
          if (response.status) {
            this.toast.success("La ola de preparacion se asigno correctamente.");
            this.loadList(this.service);
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.toast.error(response.message);
            } else {
              this.toast.error(response.msg);
            }
          }
        })
        .catch((e) => {
          this.toast.error(e);
        })
        .finally(() => {
          this.loading_assign = false;
          this.assignment_modal = false;
        });
    },
    createPickingDetail(item = null) {
      if (item && item.id) {
        this.almacen_selected = { id: item.almacen_id, name: item.almacen_name, code: item.almacen_code };
        // Modo individual
        this.selected = [item.id];
        this.is_single_reserve = true;
        this.dialog_picking_detail = true;
      } else {
        // Modo masivo
        this.is_single_reserve = false;
        if (this.selected.length === 0) {
          this.toast.error("No se ha seleccionado ninguna orden de envío");
          return;
        }
        this.selected_items = this.list.filter((item) => this.selected.includes(item.id));

        //Validar que todos los selected_items sean del mismo almacen
        const almacen_id = this.selected_items[0].almacen_id;
        const all_same_almacen = this.selected_items.every((item) => item.almacen_id === almacen_id);
        if (!all_same_almacen) {
          this.selected_items = [];
          this.toast.error("Los items seleccionados deben pertenecer al mismo almacen");
          return;
        }

        this.almacen_selected = { id: this.selected_items[0].almacen_id, name: this.selected_items[0].almacen_name, code: this.selected_items[0].almacen_code };
        this.dialog_view_reservar = true;
      }
    },

    confirmPickDetail(shipment_order_id, item) {
      if (this.loading_picking_detail) return;

      if (this.selected_shipment_order != null && isNaN(this.selected_shipment_order.id)) {
        this.selected.push(this.selected_shipment_order.id);
      }

      if (this.selected.length === 0) {
        this.toast.error("No se ha seleccionado ninguna orden de envío");
        return;
      }

      const data = {
        shipment_order_ids: [shipment_order_id],
        dock: { id: item.id },
      };

      this.loading_picking_detail = true;

      // retorno el response para que se pueda leer en componente hijo ModalReservarStock
      return this.service
        .generatePickingDetail(data)
        .then((response) => {
          if (response.status === true) {
            if (this.is_single_reserve) {
              this.toast.success(response.msg, { dangerouslyHTMLString: true });
            }
            this.dialog_picking_detail = false;
          } else {
            this.toast.error(response.msg, { dangerouslyHTMLString: true });
          }
          return response;
        })
        .catch((e) => {
          console.error("Error al generar picking detail", e);
          throw e;
        })
        .finally(() => {
          this.loading_picking_detail = false;
        });
    },
    filter() {
      this.loadList(this.service);
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadClientes() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadSubClients() {
      this.loading_sub_clients = true;
      subClientService
        .filter({})
        .then((response) => {
          // Se listan todos los puntos de entrega indicando el cliente al que pertenecen
          this.sub_clients = response.result.list.map((sc) => ({
            ...sc,
            label: !this.isClient() && sc.client ? sc.name + " (" + sc.client.name + ")" : sc.name,
          }));
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_sub_clients = false;
        });
    },
    loadDocumentTypes() {
      documentsTypeService
        .filter({ order_type: "OUT" })
        .then((response) => {
          this.documents_types = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadStatus() {
      shipmentOrderService
        .list_status()
        .then((response) => {
          this.status = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    cancelReserve(item) {
      if (this.selected.length == 0) {
        if (!item) {
          this.toast.error("No se ha seleccionado ninguna orden de envio");
          return;
        } else {
          this.selected.push(item.id);
        }
      }
      this.dialog_cancel = true;
    },
    cancelReserveConfirm(item) {
      if (this.loading_cancel) return;

      if (this.selected.length == 0) {
        this.toast.error("No se ha seleccionado ninguna orden de envio");
        return;
      }

      const data = {
        //shipment_order_id: this.selected_shipment_order.id,
        shipment_order_ids: this.selected,
      };
      this.loading_cancel = true;
      this.service
        .cancel_reserve(data)
        .then((response) => {
          if (response.status) {
            this.toast.success("La reserva de la orden de envio se cancelo correctamente.");
            this.dialog_cancel = false;
            this.selected = [];
            this.filter();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_cancel = false;
        });
    },
    cancelShipment(item) {
      if (this.selected.length == 0) {
        if (!item) {
          this.toast.error("No se ha seleccionado ninguna orden de envio");
          return;
        } else {
          this.selected.push(item.id);
        }
      }
      this.dialog_cencel_shipment = true;
    },
    createPickingSelected() {
      this.cancelReserveConfirm();
    },
    cancelSelected() {
      this.cancelReserveConfirm();
    },
    cancelShipmentConfirm(item) {
      if (this.loading_cancel_shipment) return;

      if (this.selected.length == 0) {
        this.toast.error("No se ha seleccionado ninguna orden de envio");
        return;
      }

      const data = {
        shipment_order_ids: this.selected,
      };
      this.loading_cancel_shipment = true;
      this.service
        .cancel_shipment(data)
        .then((response) => {
          if (response.status) {
            this.toast.success("La orden de envio se cancelo correctamente.");
            this.dialog_cencel_shipment = false;
            this.selected = [];
            this.filter();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        })
        .finally(() => {
          this.loading_cancel_shipment = false;
        });
    },
    isSuperUser() {
      return localStorage.getItem("user_type") == this.userTypeConstant.SUPERUSER;
    },
    closeForceClosePicking() {
      this.dialog_force_close_picking = false;
      this.force_close_order = null;
      this.force_close_details = [];
      this.incidencias_map = {};
      this.loading_force_close_details = false;
    },

    openForceClosePicking(item) {
      this.force_close_order = item;
      this.force_close_details = [];
      this.incidencias_map = {};
      this.dialog_force_close_picking = true;
      this.loading_force_close_details = true;
      pickingDetailService
        .filter({ shipment_order_id: item.id })
        .then((response) => {
          if (response.status) {
            this.force_close_details = response.result && Array.isArray(response.result.list) ? response.result.list : [];
          }
        })
        .catch((e) => {
          console.log("pickingDetailService.filter error", e);
        })
        .finally(() => {
          this.loading_force_close_details = false;
        });
      this.loadIncidencias(item);
    },
    loadIncidencias(item) {
      incidenciaService
        .filter({ shipment_order_code: item.code })
        .then((response) => {
          const map = {};
          if (response.result && response.result.list) {
            response.result.list.forEach((inc) => {
              if (inc.picking_detail_id) {
                map[inc.picking_detail_id] = inc;
              }
            });
          }
          this.incidencias_map = map;
        })
        .catch((e) => {
          console.log("incidenciaService.filter error", e);
        });
    },
    openIncidencia(incidencia) {
      this.selected_incidencia = incidencia;
      this.dialog_incidencia = true;
    },
    forceClosePickingConfirm() {
      if (this.loading_force_close) return;
      this.loading_force_close = true;
      this.service
        .force_close_picking({ shipment_order_id: this.force_close_order.id })
        .then((response) => {
          if (response.status) {
            this.toast.success("Cierre forzado realizado correctamente.");
            this.closeForceClosePicking();
            this.loadList(this.service);
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          console.log("service.force_close_picking error", e);
          this.toast.error("Ocurrió un error al realizar el cierre forzado.");
        })
        .finally(() => {
          this.loading_force_close = false;
        });
    },    
    deleteShipmentOrders(item) {
      
      if (this.selected.length == 0) {
        if (!item) {
          this.toast.error("No se ha seleccionado ninguna orden de envio");
          return;
        } else {
          this.selected.push(item.id);
        }
      }
      this.dialog_delete = true;
    },
    deleteItemConfirm() {
      if (this.loadingSubmit) return;

      if (this.selected.length == 0) {
        this.toast.error("No se ha seleccionado ninguna orden de envio");
        return;
      }

      const data = {
        shipment_order_ids: this.selected,
      };
      this.loadingSubmit = true;
      this.service
        .remove(data)
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg);
            this.dialog_delete = false;
            this.selected = [];
            this.filter();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          console.log("service.remove error");
          console.log(e);
          this.toast.error("Error al eliminar las órdenes de envío");
        })
        .finally(() => {
          this.loadingSubmit = false;
        });
    },
    openViewLpn(item) {
      this.shipment_order_id = item.id;
      this.almacen_item = { id: item.almacen_id, name: item.almacen_name, code: item.almacen_code };
      this.code_item = item.code;
      this.dialog_view_lpn = true;
    },
    openShipLpn(item) {
      this.shipment_order_selected = item;
      this.almacen_item = { id: item.almacen_id, name: item.almacen_name, code: item.almacen_code };
      this.code_item = item.code;
      this.dialog_ship_lpn = true;
    },
    closeDialogViewLpn() {
      this.shipment_order_id = null;
      this.almacen_item = null;
      this.code_item = null;
      this.dialog_view_lpn = false;
    },
    closeDialogShipLpn() {
      this.shipment_order_selected = null;
      this.almacen_item = null;
      this.code_item = null;
      this.dialog_ship_lpn = false;
    },
    toggleExpand(item) {
      const itemId = item.id;
      const index = this.expandedItems.indexOf(itemId);
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(itemId);
      }
    },
    isExpanded(item) {
      return this.expandedItems.includes(item.id);
    },
    toggleExpandAll() {
      if (this.allExpanded) {
        this.expandedItems = [];
      } else {
        this.expandedItems = this.list.map((item) => item.id);
      }
      this.allExpanded = !this.allExpanded;
    },
    exportFile() {
      var param = { ...this.getFilterParams() }; // Copia de this.filters
      param["export"] = true;
      this.exportExcel(this.service.section + "/export", param, "OrdenesDeEnvio.xlsx");
    },
    openPrintTmsModal(item) {
      this.shipment_order_for_print = item;
      this.dialog_print_tms = true;
    },
    openPrintWitnessModal(item) {
      this.shipment_order_for_witness = item;
      this.dialog_print_witness = true;
    },
    openFilterModal() {
      this.dialog_filters = true;
    },
    closeFilterModal() {
      this.dialog_filters = false;
    },
    updateFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
    },
    applyFilters() {
      this.filter();
      this.closeFilterModal();
    },
    removeFilter(index) {
      const filtered = this.selected_filters[index];
      this.selected_filters.splice(index, 1);

      if (filtered.key) {
        // Si es el filtro de not_synced_tms, resetear a false en lugar de null
        if (filtered.key === 'not_synced_tms') {
          this.filters[filtered.key] = false;
        } else if (filtered.key === 'clients' || filtered.key === 'canal_venta' || filtered.key === 'sub_clients') {
          this.filters[filtered.key] = [];
        } else if (filtered.key === 'status') {
          // Si es status, resetear a array vacío
          this.filters[filtered.key] = [];
        } else {
          this.filters[filtered.key] = null;
        }
      }

      this.filter();
    },
  },
};
</script>

<style scoped>
.bg-grey-lighten-5 {
  background-color: #fafafa;
}
</style>
